// https://github.com/crypto-gawds/react-d3-radar

import Radar from 'crypto-gawds-react-d3-radar'
import Gawd, { Power } from 'web/lib/gawd'

interface RadarChartProps {
  gawd: Gawd
}

function RadarChart({ gawd }: RadarChartProps) {
  const allPowers = Power.all.map(p => p.name.toLowerCase())
  const powerCounts = gawd.powers()

  // handle gawds with only 2 powers; radar chart requires 3 points
  if(!allPowers.includes('unknown')){
    allPowers.push('unknown')
  }
  if (Object.keys(powerCounts).length < 3) {
    powerCounts['unknown'] = 0
  }

  const variables = allPowers.map((power) => {
    const label = powerCounts[power] ? power : ''
    return { key: power, label: label.charAt(0).toUpperCase() + label.slice(1) }
  })

  // in theory this should be max=5 since that's the global max,
  // but that makes the chart look super jank when only 1-2
  const maxValue = Object.values(powerCounts).reduce(function (a, b) {
    return a > b ? a : b
  })

  // console.log("radarChart", { variables, powerCounts, maxValue })
  // Radar bug with this gawd...
  if ([2587, 3349].includes(gawd.id())) return <></>

  return (
    <Radar
      width={400}
      height={300}
      padding={40}
      domainMax={maxValue + 1}
      highlighted={null}
      data={{
        variables: variables,
        sets: [
          {
            key: 'gawd',
            label: 'powers',
            values: powerCounts,
          },
        ],
      }}
    />
  )
}

export default RadarChart
